// The DB stores wall-clock Oslo time and mysql2 (timezone: 'local') hands it back as a real Date,
// so the ISO string that reaches us already carries the offset — read it with local getters, never UTC ones

const pad = (n) => String(n).padStart(2, '0');

// Accepts the ISO string a serialized Date arrives as, a "YYYY-MM-DD HH:mm:ss" string, or a Date
const toDate = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

// HH:mm:ss for the time column of the table screens
export const timeOfDay = (value) => {
  const d = toDate(value);
  if (!d) return '';
  return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

// YYYY-MM-DD HH:mm:ss when the row can span several days
export const dateTime = (value) => {
  const d = toDate(value);
  if (!d) return '';
  return `${dayStamp(d)} ${timeOfDay(d)}`;
};

// YYYY-MM-DD of a date; toISOString() would give the previous day between 00:00 and 02:00 Oslo
export const dayStamp = (value = new Date()) => {
  const d = toDate(value);
  if (!d) return '';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// The day the operator is looking at right now
export const todayLocal = () => dayStamp(new Date());
